export const BASE_ERROR_NOTIFICATION_PARAMS = {
  color: 'red',
  title: 'Error',
};

export const BASE_SUCCESS_NOTIFICATION_PARAMS = {
  color: 'green',
  title: 'Success',
};
